import React from 'react';
import {useDispatch} from 'react-redux';
import FieldSalesLeaderSelect from 'Users/components/UserAdministration/UserEntry/FieldSalesLeaderSelect';
import {addFieldSalesLeader, removeFieldSalesLeader} from 'Users/ducks/fieldVicePresidentUserType';
import {FieldVicePresidentUserType} from 'Users/models/User/Agent/FieldVicePresidentUserType';
import './FieldVicePresidentUserTypeEntry.sass';

type FieldVicePresidentUserTypeProps = {
  fieldVicePresidentUserType: FieldVicePresidentUserType;
  hasUpdateAccess: boolean;
  isEdit: boolean;
};

const FieldVicePresidentUserTypeEntry = (props: FieldVicePresidentUserTypeProps) => {
  const {fieldVicePresidentUserType, hasUpdateAccess, isEdit} = props;
  const dispatch = useDispatch();

  return (
    <div className="field-vice-president-entry-section">
      <FieldSalesLeaderSelect
        className="field-vice-president-entry-section__field-sales-leader-input"
        onAddFieldSalesLeader={fsl => dispatch(addFieldSalesLeader(fsl))}
        onRemoveFieldSalesLeader={fsl => dispatch(removeFieldSalesLeader(fsl))}
        fieldSalesLeaders={fieldVicePresidentUserType.fieldSalesLeaders}
        disabled={!hasUpdateAccess && isEdit}
      />
    </div>
  );
};

export default FieldVicePresidentUserTypeEntry;
